import React, { useEffect } from 'react';
import { Box, Drawer, DrawerContent, useColorModeValue, useDisclosure } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

// Components
import { Footer, Sidebar, TopBar } from '../components';
import { ILinkItem } from '../interfaces';
import { useAppDispatch, useAppSelector } from '../state/hooks';
import { me } from '../state/user';
import ErrorBoundary from '../ErrorBoundary';
import { getDoctor } from '../state/doctor';
import { ProfileConstants } from '../constants';

interface ILayout {
    links: ILinkItem[];
}

export const Layout = (props: ILayout): JSX.Element => {
    const {links} = props;
    const { user, loading } = useAppSelector(state => state.user);

    const dispatch = useAppDispatch();
    const { isOpen, onOpen, onClose } = useDisclosure();

    useEffect(() => {
        if(!loading && !user) {
            dispatch(me());
        }
    }, []);

    useEffect(() => {
        if(user && user.role_id === ProfileConstants.DOCTOR) {
            dispatch(getDoctor());
        }
    }, [user?.role_id]);

    return (
        <Box minH="100vh" bg={useColorModeValue('gray.100', 'gray.900')}>
            <Sidebar
                LinkItems={links}
                onClose={onClose}
                display={{ base: 'none', md: 'block' }}
            />
            <Drawer
                autoFocus={false}
                isOpen={isOpen}
                placement="left"
                onClose={onClose}
                returnFocusOnClose={false}
                onOverlayClick={onClose}
                size="sm">
                <DrawerContent>
                    <Sidebar LinkItems={links} onClose={onClose} />
                </DrawerContent>
            </Drawer>
            {/* nav */}
            <TopBar onOpen={onOpen}/>
            <Box ml={{ base: 0, md: 60 }}>
                <Box p="4" minH="88.5vh">
                    <ErrorBoundary>
                        <Outlet />
                    </ErrorBoundary>
                </Box>
                <Footer />
            </Box>
        </Box>
    );
};
